var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 15.0003C3.33301 14.1163 3.6842 13.2684 4.30932 12.6433C4.93444 12.0182 5.78229 11.667 6.66634 11.667H13.333C14.2171 11.667 15.0649 12.0182 15.69 12.6433C16.3152 13.2684 16.6663 14.1163 16.6663 15.0003C16.6663 15.4424 16.4907 15.8663 16.1782 16.1788C15.8656 16.4914 15.4417 16.667 14.9997 16.667H4.99967C4.55765 16.667 4.13372 16.4914 3.82116 16.1788C3.5086 15.8663 3.33301 15.4424 3.33301 15.0003Z",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.3335C11.3807 8.3335 12.5 7.21421 12.5 5.8335C12.5 4.45278 11.3807 3.3335 10 3.3335C8.61929 3.3335 7.5 4.45278 7.5 5.8335C7.5 7.21421 8.61929 8.3335 10 8.3335Z",
    stroke: "black",
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.720f4848d238c24c768f9e24ac5f1258.svg";
export { ForwardRef as ReactComponent };